import type { SVGProps } from "react";

export default function PerformanceIcon(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.625 9.03711C9.74767 8.68103 10.2534 8.68195 10.375 9.03906L10.7793 10.2461L11.0449 11.0586V11.0596C11.3933 12.1413 11.6502 13.0036 11.8193 13.665C11.9916 14.3389 12.0625 14.7674 12.0625 15C12.0625 16.1391 11.1391 17.0625 10 17.0625C8.86106 17.0623 7.9375 16.139 7.9375 15C7.9375 14.7364 8.02878 14.2303 8.24609 13.4189C8.45944 12.6225 8.78283 11.5722 9.22168 10.2441L9.2207 10.2432L9.62598 9.03809L9.625 9.03711ZM9.58203 11.7031L9.30859 12.5869L9.30664 12.5928L9.11816 13.2354L9.11719 13.2383C8.99325 13.6717 8.89746 14.0344 8.83301 14.3203C8.77141 14.5936 8.72949 14.8325 8.72949 15C8.72949 15.7018 9.29829 16.2703 10 16.2705C10.7019 16.2705 11.2715 15.7019 11.2715 15C11.2715 14.8011 11.21 14.4895 11.1191 14.1172C11.0242 13.728 10.884 13.2242 10.7002 12.6143L10.6992 12.6113L10.418 11.7031L10 10.3525L9.58203 11.7031ZM10 2.9375C14.3606 2.9375 17.8963 6.47241 17.8965 10.833C17.8965 12.4173 17.428 13.9335 16.5654 15.2217C16.4437 15.403 16.1981 15.4515 16.0166 15.3301C15.835 15.2085 15.7867 14.9629 15.9082 14.7812C16.6845 13.6219 17.1045 12.2587 17.1045 10.833C17.1043 6.90963 13.9234 3.72949 10 3.72949C6.07674 3.72967 2.89666 6.90974 2.89648 10.833C2.89648 12.2587 3.31647 13.6219 4.09277 14.7812C4.21415 14.9629 4.16589 15.2085 3.98438 15.3301C3.80275 15.4517 3.55622 15.4033 3.43457 15.2217C2.57196 13.9335 2.10449 12.4173 2.10449 10.833C2.10467 6.47252 5.63951 2.93768 10 2.9375Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.875"
      />
    </svg>
  );
}
